import type { CurrentMax, ProgramProgress } from "@heraion/shared";

import { useEditedProgramProgress } from "@heraion/ui";

import { apiFetch } from "./api";
import { progressLsCache } from "./useFollowedPrograms";
import { useMaxesDataWeb } from "./maxes/useMaxesDataWeb";

// What a web program editor mount reads besides its seams (#336 slice 6), for
// PlanScreen and CoachLibraryScreen alike: where the caller is in the program
// (its rounds already done are locked), for any program, followed or not; and
// the MAXes once read (the grid's load lens, «ref. ≈», the %MAX warning).
// The progress is the shared hook, fed the Plan surface's localStorage markers
// and this host's apiFetch. Called on every render of the host, the program id absent while no editor
// is open.
const progressOpts = { apiFetch, readCached: progressLsCache.read };

export function useProgramEditorData(programId: string | undefined): {
  progress: ProgramProgress | null;
  maxMeta: ReadonlyMap<string, CurrentMax> | undefined;
} {
  const progress = useEditedProgramProgress(programId, progressOpts);
  const { maxMeta, loaded } = useMaxesDataWeb();
  return { progress, maxMeta: loaded ? maxMeta : undefined };
}
